// 咨询
export default [
  {
    path: '/consult/consult-admin',
    component: resolve => require(['@/pages/consult/consultAdmin.vue'], resolve),
    name: 'consult-admin',
    meta: {
      title: '迎新咨询管理'
    }
  },
  {
    path: '/consult/consult-type-operation',
    component: resolve => require(['@/pages/consult/consultTypeOperation.vue'], resolve),
    name: 'consult-type-operation',
    meta: {
      title: '咨询类型管理'
    }
  },
  {
    path: '/consult/consult-Scope',
    component: resolve => require(['@/pages/consult/consultScope.vue'], resolve),
    name: 'consult-Scope',
    meta: {
      title: '处理范围'
    }
  },
  {
    path: '/approval/consultScopeAddEdit',
    component: resolve => require(['@/pages/consult/consultScopeAddEdit.vue'], resolve),
    name: 'consultScopeAddEdit',
    meta: {
      title: '处理范围'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/consult.js